import { request } from "../../../Services/Api"

export const getPricing = (params) => request.api.get("/billing/pricing/", params)
export const getAllPricingSchemes = () => request.api.get("/billing/pricing/users-pricing/")
export const getPricingFilterOptions = () => request.api.get("/billing/pricing/filter_options/")
export const createPricing = (data) => {
  if (data.type === "Volume based") {
    return request.api.post(`/billing/pricing/create_volume_based_pricing/`, data)
  }
  return request.api.post(`/billing/pricing/`, data)
}
export const updatePricing = ({ id, type, ...data }) => {
  if (type === "Volume based") {
    return request.api.patch(`/billing/pricing/${id}/update_volume_based_pricing/`, data)
  }
  return request.api.put(`/billing/pricing/${id}/`, data)
}
export const deletePricing = (id) => request.api.delete(`/billing/pricing/${id}/`)

export const getLookupPricing = (params) => request.api.get("/billing/lookup-pricing/", params)
export const getLookupPricingAssignmentOptions = () =>
  request.api.get("/billing/lookup-pricing/assignment-options/")
export const getLookupPricingFilterOptions = () =>
  request.api.get("/billing/lookup-pricing/filter_options/")
export const createLookupPricing = (data) => request.api.post("/billing/lookup-pricing/", data)
export const updateLookupPricing = ({ id, ...data }) =>
  request.api.put(`/billing/lookup-pricing/${id}/`, data)
export const deleteLookupPricing = (id) => request.api.delete(`/billing/lookup-pricing/${id}/`)
